import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerEnrichApiQuota = (enabled = true) => {
  const customerId = useCustomerId()
  return useQuery({
    queryKey: ['customer', customerId, 'enrich_api_quota'],
    queryFn: () => get(`/management/customers/${customerId}/enrich_api/usage`),
    retry: false,
    enabled,
  })
}
